import React, { useEffect, useState } from 'react';
export function CountdownBar() {
  // Start at 14:59
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-whatsapp text-white py-2 px-4 flex items-center justify-center gap-3 text-sm md:text-base font-bold tracking-wide" data-id="element-14">
      <span data-id="element-15">🔥 OFERTA ACTIVA POR TIEMPO LIMITADO</span>
      <div className="bg-white/20 px-3 py-1 rounded-md flex items-center justify-center min-w-[60px]" data-id="element-16">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </div>
      <span data-id="element-17">🔥</span>
    </div>;
}